import { useState, useEffect } from 'react'
import useAuthStore from 'store/auth'
import { UserIcon } from './svg'
import SideBar from './SideBar'
import { useTrader } from 'context/TraderTypeContext';

const TopBar = () => {
  const user = useAuthStore((state) => state.user);
  const { traderId, setTraderId } = useTrader();
  const [selectedTrader, setSelectedTrader] = useState<string>('');
  const [isNavOpen, setIsNavOpen] = useState(false);
  const closeNav = ():void => setIsNavOpen(false);
  
  useEffect(() => {
    if (user && user.traders.length > 0 && traderId) {
      const currentTrader = user.traders.find(trader => trader.traderId.toString() === traderId);
      if (currentTrader) {
        setSelectedTrader(currentTrader.name);
      }
    }
  }, [user, traderId]);

  const handleTraderChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (user && user.traders.length > 0) {
      const newSelectedTrader = event.target.value;
      setSelectedTrader(newSelectedTrader);
      
      const selectedTraderObj = user.traders.find((trader) => trader.name === newSelectedTrader);
      if (selectedTraderObj) {
        setTraderId(selectedTraderObj.traderId.toString());
        localStorage.setItem('selectedTrader', newSelectedTrader);
      }
    }
  };

  return (
    <>
      {/* Black BG */}
      <div 
        onClick={() => setIsNavOpen(false)}
        className={`${isNavOpen 
          ? "transition ease duration-200 md:hidden opacity-60 z-10" 
          : "hidden opacity-0 z-0"} bg-black w-full h-full fixed`}
      />
      <SideBar 
        customClass={isNavOpen 
          ? "md:hidden fixed bg-opacity-100 h-full left-0 opacity-100" 
          : "md:hidden fixed bg-opacity-100 h-full -left-52 opacity-0"} 
        navOpen={isNavOpen}
        setNavClose={closeNav}  
      />

      <header className="flex items-center justify-between md:justify-end py-0 -left h-14 -left px-4 -left bg-white bg-opacity-50 scale">
      { user && user?.traders.length !== 0 &&
        <div className='text-sm'>
          <label htmlFor="centre" className='mr-2'>Current Centre:</label>
          <select
            id="centre"
            className="mr-12 py-1 px-2 rounded border"
            value={selectedTrader}
            onChange={handleTraderChange}
          >
            {user && user.traders.map((trader) => (
              <option key={trader.traderId} value={trader.name}>
                {trader.name}
              </option>
            ))}
          </select>
        </div>
        }
        <div className='flex items-center'>
          <span className="text-sm text-gray-700">
            Hi, <span className="font-bold">{user?.login}</span>
          </span>
          <div className="p-1 ml-4 text-gray-500 bg-white rounded-full shadow bg-opacity-80">
            <UserIcon />
          </div>
        </div>
      </header>
    </>
  )
}

export default TopBar